var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCorrecto(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.02687C6.49058 2.02687 2.02686 6.49059 2.02686 12C2.02686 17.5094 6.49058 21.9731 12 21.9731C17.5094 21.9731 21.9731 17.5094 21.9731 12C21.9731 6.49059 17.5094 2.02687 12 2.02687ZM17.5324 9.36967L10.2127 16.1643C10.1482 16.2472 10.0699 16.3209 9.97772 16.3854C9.4664 16.7401 8.7616 16.6157 8.40689 16.1044L6.31092 13.101C5.95622 12.5896 6.0806 11.8848 6.59192 11.5301C7.10325 11.1754 7.80805 11.2998 8.16275 11.8111L9.51246 13.7413L16.0031 7.71593C16.4591 7.29213 17.1731 7.31977 17.5969 7.77582C18.0161 8.23186 17.9885 8.94587 17.5324 9.36967Z",
    fill: "#6BAC6C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrecto);
export default __webpack_public_path__ + "static/media/Correcto.d8c49f4c.svg";
export { ForwardRef as ReactComponent };